var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.tariffs),function(tariff,i){return [(_vm.current === i)?_c('pricing-tariffs-features-slider',{key:`slider-${i}`,attrs:{"tariff":tariff}}):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }